import { createRoot } from 'react-dom/client';

import '@/i18n/i18n';

import { fetchSettings } from '@/config/settingsApi';
import { useBrandingStore } from '@/stores/useBrandingStore';
// Import direction store to activate the i18n.on('languageChanged') listener.
// This must happen before React renders so the listener is ready.
import '@/stores/useDirectionStore';

import { App } from './App';

const RTL_LANGUAGES = new Set(['ar']);

async function bootstrap() {
  try {
    const settings = await fetchSettings();
    useBrandingStore.getState().setBranding(settings);
  } catch {
    // Settings fetch failed — app renders with default Talinty colors
  }

  // Set document dir eagerly from persisted language to avoid LTR flash
  // before React renders. The direction store is already initialized from
  // i18n.language and stays in sync via the languageChanged listener.
  const savedLang = localStorage.getItem('i18nextLng');
  if (savedLang && RTL_LANGUAGES.has(savedLang)) {
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = savedLang;
  }

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found. Ensure index.html contains a div with id="root".');
  }

  createRoot(rootElement).render(<App />);
}

void bootstrap();
